export const MUTATION_LOG_ON_OUT = 'log_on_out';
export const MUTATION_SET_BASIS = 'mutation#set_basis';
export const MUTATION_SET_PERMISSION = 'mutation#set_permission';
export const MUTATION_SET_MENU = 'mutation#set_menu';
export const ACTION_RELOAD_BASIS = 'action#fetch_basis';
export const ACTION_GET_PERMISSION = 'action#get_permission';
